import { useState, useEffect } from 'react';
import { AuthConfirmPage } from './auth/AuthConfirmPage';
import { DesktopAuthConfirmPage } from './desktop/DesktopAuthConfirmPage';

export function ResponsiveAuthConfirmPage() {
  const [isMobile, setIsMobile] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 1024);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return isMobile ? <AuthConfirmPage /> : <DesktopAuthConfirmPage />;
}